export default "__VITE_ASSET__fbc58b6e__"